export const ECourierVehicleType = {
  MotorCycle: 0,

  Bike: 1,

  Car: 2,

  Others: 3,
}

export type ECourierVehicleType = (typeof ECourierVehicleType)[keyof typeof ECourierVehicleType]
